import axios from "axios";
export default {
  async getLoansInfo(encoded) {
    console.log("url: " + process.env.VUE_APP_QPAY_URL)
    return axios.get(`/view/${encoded}`);
  },

  async getQr(encoded) {
    console.log("url: ", process.env.VUE_APP_QPAY_URL)
    return axios.get(`/pay/${encoded}`)
  }

}